export interface ICreativeTargetingCriterionValueAPI {
  creativetargetingcriterionvalue_id: number;
  creativetargetingcriterion_id: number;
  code: string;
  value: string;
}

export interface ICreativeTargetingCriterionAPI {
  creative_id: number;
  targetingcriterion_id: number;
  creativetargetingcriterion_values: ICreativeTargetingCriterionValueAPI[];
}

export default class CreativeTargetingCriterion {
  creativeID: number;

  targetingCriterionID: number;

  values: ICreativeTargetingCriterionValueAPI[];

  constructor(creativeID: number, targetingCriterionID: number, values: ICreativeTargetingCriterionValueAPI[] = []) {
    this.creativeID = creativeID;
    this.targetingCriterionID = targetingCriterionID;
    this.values = values;
  }

  static fromApi(apiObject: ICreativeTargetingCriterionAPI): CreativeTargetingCriterion {
    const creativeTargetingCriterion = new CreativeTargetingCriterion(
      apiObject.creative_id,
      apiObject.targetingcriterion_id,
      apiObject.creativetargetingcriterion_values,
    );
    return creativeTargetingCriterion;
  }

  toApi(): ICreativeTargetingCriterionAPI {
    return {
      creative_id: this.creativeID,
      targetingcriterion_id: this.targetingCriterionID,
      creativetargetingcriterion_values: this.values,
    };
  }
}
